import { gql } from '@apollo/client';
const ADD_PRODUCT_SUSTAINABILITY = gql `
  mutation AddProductSustainability($name: String!, $description: String, $thumbnail: String) {
    addProductSustainability(name: $name, description: $description, thumbnail: $thumbnail) {
      productSustainability {
        id
        name
        description
        thumbnail
      }
    }
  }
`;
export default ADD_PRODUCT_SUSTAINABILITY;
